// extracted by mini-css-extract-plugin
export default {"container":"SketchLibrary_container__P4dLm","picture":"SketchLibrary_picture__jTF1w","btnIcon":"SketchLibrary_btnIcon__mtoFK"};